import { Command } from "commander";
import { discoverSkills } from "agent-install/skill";
import { handleError } from "../utils/handle-error.js";
import { highlighter } from "../utils/highlighter.js";
import { logger } from "../utils/logger.js";
import { resolveBundledSkillsDir } from "../utils/resolve-skills-dir.js";

export const list = new Command()
  .name("list")
  .alias("ls")
  .description("list all available React Stack skills")
  .action(async () => {
    try {
      const skillsDir = resolveBundledSkillsDir();
      const availableSkills = await discoverSkills(skillsDir);

      if (availableSkills.length === 0) {
        logger.warn("No skills found.");
        return;
      }

      logger.break();
      logger.log(highlighter.bold("Available React Stack skills:"));
      logger.break();
      for (const innerSkill of availableSkills) {
        logger.log(`  ${highlighter.info(innerSkill.name)}`);
        logger.log(`    ${highlighter.dim(innerSkill.description)}`);
        logger.break();
      }
    } catch (error) {
      handleError(error);
    }
  });
